import axios, { AxiosError } from 'axios';
import { HTTP_STATUS_CODES } from 'Enum/HttpStatusCodes';
import { msalInstance } from 'index';
import { getTokenFromUrl } from 'Utils';

export const api = axios.create({
  baseURL: process.env.REACT_APP_DOMAIN,
});

const notAuthAction = async () => {
  if (
    !window.location.pathname
      .toLowerCase()
      .includes('universalRequest'.toLocaleLowerCase())
  )
    await msalInstance.loginRedirect();
};

api.interceptors.request.use(
  async function (config) {
    const token =
      sessionStorage.getItem('B2CToken') ||
      getTokenFromUrl() ||
      sessionStorage.getItem('token');

    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    };
    return config;
  },
  async function (error: AxiosError) {
    if (
      error.response?.status === HTTP_STATUS_CODES.Unauthorized ||
      error.response?.status === HTTP_STATUS_CODES.Forbidden
    ) {
      notAuthAction();
    }
    return error;
  }
);

api.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error: any) {
    console.log(error);
    if (
      error.response?.status === HTTP_STATUS_CODES.Unauthorized ||
      error.correlationId
    ) {
      notAuthAction();
    }
    return error;
  }
);
